// extracted by mini-css-extract-plugin
module.exports = {"Root":"Breadcrumb_Root___okQA","BreadCrumb":"Breadcrumb_BreadCrumb__mo0yD"};